import { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import { shallow } from "zustand/shallow";
import * as yup from "yup";

import { InputText, InputTextArea } from "../../../../common/UI/Inputs";
import AppGetIcon from "../../../../common/UI/AppGetIcon";
import DataTable from "../../../../common/UI/DataTable/dataTable";
import Modal from "../../../../common/UI/Modal";
import AppInputSearch from "../../../../common/UI/Inputs/appInputSearch";
import iconPassView from "../../assets/login/icon-pass-view.svg";
import iconPass from "../../assets/login/icon-pass.svg";
import { useHeaderStore } from "../../../../store/header.store";
import { GetRolesService } from "../../services/admin/permissionRoles/getRoles.service";

import style from "./Environment.module.css";
import styleButton from "../../../../common/theme/styles/button.module.css";
import styleForm from "../../../../common/theme/styles/form.module.css";
import styleDataTable from "../../../../common/UI/DataTable/dataTable.module.css";
import { toast } from "react-toastify";
import { DeleteUserService } from "../../services/admin/deleteUser.service";
import { GetEnvironmetService } from "../../services/environment/getEnvironment.service";
import { GetEnvironmetByApiService } from "../../services/environment/getEnvironmentByApi.service";
import { UpdateEnvironmentValuesService } from "../../services/environment/updateEnvironmentValues.service";
import AppButton from "../../../../common/UI/Buttons/AppButton";



// Schema ajustado a todos los campos del formulario
// 1) Añade `id` al esquema para que yup lo conozca:

export default function Environment() {
  const headerStore = useHeaderStore(
    (state) => ({
      setModule: state.setModule,
      setModuleItem: state.setModuleItem,
    }),
    shallow
  );

  const [loading, setLoading] = useState(false);
  const [isReloadData, setIsReloadData] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [environmentFields, setEnvironmentFields] = useState<any>({});

  const columns = [
    {
      header: 'Clave de API',
      field: 'apiKey',
    },
    {
      header: 'Nombre del servicio',
      field: 'name',
    },
    {
      header: "OPCIONES",
      field: "",
      render: (row: any) => (
        <AppButton
          className={styleDataTable.buttom_option}
          variant='primary'
          iconName='edit'
          buttonText="Editar"
          onClick={() => handleEdit(row)}

        />
      ),
    },
  ];
  const GetEnvironmentPaginatedService = {
    run: async ({ page = 1, perPage = 10, search = '' }) => {

      const response = await GetEnvironmetService();
      const allData = response ?? [];

      const filtered = allData.filter((item: any) =>
        item.name?.toLowerCase().includes(search.toLowerCase()) ||
        item.apiKey?.toLowerCase().includes(search.toLowerCase())
      );

      const total = filtered.length;
      const startIndex = (page - 1) * perPage;
      const paginatedData = filtered.slice(startIndex, startIndex + perPage);

      const result = {
        data: paginatedData,
        page,
        perPage,
        total
      };
      return result;
    }
  };
  const handleEdit = async (row: any) => {
    const params = {
      apiServiceId: row.apiServiceId,
    };
    const response = await GetEnvironmetByApiService(params);

    // Transformar a objeto con key por ID
    const transformed = response.reduce((acc: any, item: any) => {
      acc[item.environmentParameterValueId] = {
        value: item.value,
        name: item.environmentParameter.name,
        environmentParameterValueId: item.environmentParameterValueId,
      };
      return acc;
    }, {});


    setEnvironmentFields(transformed);
    setIsEditMode(true);
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setEnvironmentFields([]);
    setIsEditMode(false);
  }
  // 3. Llama al servicio en handleSubmit
  const handleSubmit = async (values: any) => {
    setLoading(true);

    // Transforma a array de solo los campos requeridos
    const environmentValues = Object.values(values.environmentFields).map((env: any) => ({
      environmentParameterValueId: env.environmentParameterValueId,
      value: env.value
    }));

    try {
      // 🔁 Aquí debes llamar el servicio que guarda los valores
      await UpdateEnvironmentValuesService(environmentValues);

      toast.success(
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <AppGetIcon name="checkCircleFill" />
          Variables actualizadas correctamente
        </div>,
        { icon: false }
      );
      setIsOpen(false);
      setIsReloadData(prev => !prev);
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message || "Error";
      toast.error(
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <AppGetIcon name="xCircleFill" />
          {errorMessage}
        </div>,
        { icon: false }
      );
    } finally {
      setLoading(false);
    }
  };


  const addButton = () => {
    setIsOpen(true);
  };
  useEffect(() => {
    headerStore.setModule("Administración", "");
    headerStore.setModuleItem("Administrar variables", "/admin/home");
    // (async () => {
    //   const roles = await GetRolesService();
    //   setRolesData(roles.map((r: any) => ({ value: r.id, label: r.name })));
    // })();
  }, [headerStore]);

  return (
    <div className={style.containerQr}>
      <DataTable
        title="Lista de APIS"
        columns={columns}
        service={GetEnvironmentPaginatedService}
        reloadData={false}
        excelButton={{
          enabled: true,
          nameFile: 'Variables de entorno',
          getExcelData: (data) => data.map((row) => ({
            'ID': row.apiServiceId,
            'CLAVE API': row.apiKey,
            'NOMBRE': row.name,
          }))
        }}
      >
        {''}
      </DataTable>


      <Modal
        title={isEditMode ? "Editar variable" : "Crear variable"}
        isOpen={isOpen}
        onClose={handleCloseModal}
        size={{ width: "80%", maxWidth: "1200px", height: "" }}
        loadingModal={loading}
        footerContent={
          <div className={style.containerButtoms}>
            <button
              className={styleForm.buttomFooter + " " + styleForm.buttom_cancelar}
              onClick={handleCloseModal}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className={styleForm.buttomFooter}
              form="userForm"
              disabled={loading}
            >
              Guardar
            </button>
          </div>
        }
      >
        <Formik
          initialValues={{
            environmentFields: environmentFields, // 👈 se incluye para mapear los inputs
          }}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          {({ values }) => (
            <Form id="userForm" className="flex-row">
              {/* Campos de nombre, apellido y correo */}


              {/* Tabla de parámetros de entorno */}
              <div className={styleDataTable.envWrapper}>
                <h3 className={styleDataTable.envTitle}>Parámetros de entorno</h3>
                <div className={styleDataTable.envTableResponsive}>
                  <table className={styleDataTable.envTable}>
                    <thead>
                      <tr>
                        <th className={styleDataTable.envHeader + ' ' + styleDataTable.colName}>NOMBRE</th>
                        <th className={styleDataTable.envHeader + ' ' + styleDataTable.colValue}>VALOR</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(values.environmentFields ?? {}).map(([id, data]: any, index) => {
                        const isTextArea =
                          data?.isTextarea === 1 || data?.isTextarea === "1" || data?.isTextarea === true;

                        return (
                          <tr
                            key={id}
                          >
                            <td >{data.name}</td>
                            <td >
                              <div className={styleForm.form__container_row}>
                                <InputTextArea
                                  name={`environmentFields.${id}.value`}
                                  classNameInput={styleForm.input__inputWide}
                                  placeholder="Descripción"
                                  TextLabel="Descripción*"
                                />
                              </div>

                            </td>
                          </tr>
                        );
                      })}
                    </tbody>

                  </table>
                </div>
              </div>


            </Form>
          )}
        </Formik>


      </Modal>

    </div>
  );
}